import React, { FC } from 'react';
import { PageNotFound } from 'modules/PageNotFound/PageNotFound';

export const NotFound: FC<{
  title?: string;
  description?: string;
  showCTA?: boolean;
}> = ({ title, description, showCTA }) => <PageNotFound title={title} description={description} showCTA={showCTA} />;
